import { BaseQuery } from '../BaseQuery';
import { IExecutionOptions } from '../../models/query';
import { IQueryOptionsExternalApi } from '../../models/query/options';
import { ProviderKey } from '../../models/portal';
import { ExternalApiQueryMpiPortfolio } from './ExternalApiQueryMpiPortfolio';

export class ExternalApiQuery extends BaseQuery<IQueryOptionsExternalApi> {
	initialize(executionOptions: IExecutionOptions) {
		this.fillKeyFromQuery('id', 'idQuery', executionOptions);
	}
	getOptions(): IQueryOptionsExternalApi {
		const { options = {} } = this.queryOptions;
		return options.externalApi || {};
	}
	getRawValue<T = any>(executionOptions: IExecutionOptions, callStackLevel: number = 1): T {
		const externalApiRequest = this.getExternalApiRequest(this.options, executionOptions);
		if (externalApiRequest) {
			let query: BaseQuery | undefined;
			const { providerKey, name } = externalApiRequest;
			if (providerKey === ProviderKey.MPI) {
				if (name === 'portfolio') {
					query = new ExternalApiQueryMpiPortfolio(this.queryOptions, this.translationHelper);
				}
			}
			if (query) {
				return query.execute(executionOptions, callStackLevel + 1);
			}
		}
		return;
	}
}